module.exports = __webpack_public_path__ + "static/media/background-capa3.930eea1f.png";